import { GalleryPreview } from "@molecules/gallery-preview";
import React, { FC, useCallback, useMemo, useState } from "react";
import styled from "styled-components";
import ImageGallery from "react-image-gallery";
import { IconButton } from "@atoms/icon-button";
import clsx from "clsx";
import { NoSSR } from "@atoms/nossr/nossr";
import { useFHConfig } from "@templates/config";

export type GalleryProps = {
  photos: { title: string; resource: string }[];
};

export const Gallery: FC<GalleryProps> = ({ photos }) => {
  const [opened, setOpened] = useState(false);

  const handleOpenGallary = useCallback(() => setOpened(true), []);
  const handleCloseGallery = useCallback(() => setOpened(false), []);

  return (
    <NoSSR>
      <GalleryPreview
        photos={photos}
        onPhotoClick={handleOpenGallary}
        onClikShowAll={handleOpenGallary}
      />
      <FullscreenGallery
        open={opened}
        photos={photos}
        onClose={handleCloseGallery}
      />
    </NoSSR>
  );
};
const FullscreenGallery: FC<{
  open: boolean;
  photos: { title: string; resource: string }[];
  onClose?: () => void;
}> = ({ open, photos, onClose }) => {
  const config = useFHConfig();
  const images = useMemo(
    () =>
      photos.map((photo) => ({
        original: `${config.backUrl}/assets/${photo.resource}?fit=cover&width=1000&height=600`,
        thumbnail: `${config.backUrl}/assets/${photo.resource}?fit=cover&width=250&height=150`,
      })),
    [photos, config.backUrl]
  );

  return (
    <Container className={clsx(open && "open")}>
      <IconButton
        className="close-button"
        icon="close"
        title="Close"
        onClick={onClose}
      />
      {open && <ImageGallery items={images} lazyLoad />}
    </Container>
  );
};

const Container = styled.div`
  position: fixed;
  top: -100vh;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: #000;
  z-index: 1000;
  opacity: 0;
  transition: opacity 0.5s;

  &.open {
    top: 0;
    opacity: 1;
  }

  .photos {
    display: flex;
  }

  .close-button {
    position: absolute;
    right: 1rem;
    top: 1rem;
    z-index: 100;
  }

  .image-gallery {
    height: 100%;

    .image-gallery-content {
      display: flex;
      flex-direction: column;
      height: 100%;
      .image-gallery-slide-wrapper {
        flex: 1;

        .image-gallery-swipe {
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
`;
